import { HttpInterceptorFn } from '@angular/common/http';
import { languageInterceptor } from '@delen/connect-core';
import { authenticationInterceptor } from '../authentication/authentication.interceptor';
import { revokedAccessInterceptor } from '../authentication/revoked-access.interceptor';
import { unauthorizedInterceptor } from '../authentication/unauthorized.interceptor';
import { businessUnitInterceptor } from './business-unit.interceptor';

export const interceptorFunctions: HttpInterceptorFn[] = [
  languageInterceptor,
  unauthorizedInterceptor,
  revokedAccessInterceptor,
  authenticationInterceptor,
  businessUnitInterceptor,
];
